import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faSyncAlt } from '@fortawesome/free-solid-svg-icons'
import { ALLERGENS, cleanPID, DISH_PID_ADD, formatDate, fullRecipeType, RECIPE_PID_ADD } from '../../helpers/utils';

import { supabase } from '../../api'

export const RecipeForm = ({defaultItem, toggleModal, handleChange }) => {


    const [ recipe, setRecipe ] = useState(defaultItem || {});
    const [ saving, setSaving ] = useState(false);

    const save = async (cleanRecipe, newRecipe) => {

        //save recipe
        if (cleanRecipe.pid) {
          const { data, error } = await supabase
          .from('recipes')
          .update(cleanRecipe)
          .match({ pid: cleanRecipe.pid })
          .single()
          if (error) {
            console.error('error updating', error)
            return undefined
          }
          return newRecipe
        }
        else {
            const { data, error } = await supabase
            .from('recipes')
            .insert([
                cleanRecipe
            ])
            .single()
            if (error) {
                console.error('error inserting', error)
                return undefined
            }
            return newRecipe
        }
    }

      
    const handleSave = async () => {
        setSaving(true)
        const newRecipe = {...recipe, updated_at: (new Date()).toISOString()}

        setRecipe(newRecipe)
        const cleanRecipe = {...newRecipe}
        delete cleanRecipe.ingredients
        delete cleanRecipe.steps
        delete cleanRecipe.level
        delete cleanRecipe.quantity_adjusted
        delete cleanRecipe.meta

        const result = await save(cleanRecipe, newRecipe)
        setSaving(false)
        
        if (result) {
            handleChange(result)
            toggleModal()
        }
    }

    

    const portionWeight = Math.floor(10 * recipe.net_weight / (recipe.portions || 1)) / 10
    const portionMultiplier = portionWeight / 100


    const countAllergens = recipe.allergens ? recipe.allergens.split(',').length : 0

    return (
    <>
        <table style={{width:680}}>
        <tr>
            <td>Imported Name</td>
            <td>
               {recipe.name}
            </td>
        </tr>

        <tr>
            <td>Display name</td>
            <td><input style={{width:500}} name='display_name' placeholder='Name to display on recipe card'  defaultValue={recipe.display_name} onChange={e => setRecipe({...recipe, display_name: e.target.value })} /></td>
        </tr>

        <tr>
            <td>Label name</td>
            <td><input style={{width:500}} name='label_name' placeholder='Name to display on label'  defaultValue={recipe.label_name} onChange={e => setRecipe({...recipe, label_name: e.target.value })} /></td>
        </tr>

        

        <tr>
            <td>Desc</td>
            <td>
               {recipe.desc}
            </td>
        </tr>

        <tr>
            <td>Terms</td>
            <td>
               {recipe.terms}
            </td>
        </tr>
        <tr>
            <td>Quantity</td>
            <td>
               {recipe.quantity} {recipe.quantity_unit}
            </td>
        </tr>

        <tr>
            <td>Video URL</td>
            <td><input style={{width:500}} name='video_url' placeholder='URL of video'  defaultValue={recipe.video_url} onChange={e => setRecipe({...recipe, video_url: e.target.value })} /></td>
        </tr>

        {recipe.type === 'P' && <tr>
            <td>No allergens</td>
            <td><label><input disabled={countAllergens!==0} type="checkbox" name='no_allergens' defaultChecked={recipe.no_allergens} onClick={e => setRecipe({...recipe, no_allergens: e.target.checked })} />
            &nbsp;&nbsp;<span className=''>{countAllergens!==0 && <>Remove selected allergens below to change this flag</>}</span></label>
            </td>
        </tr>}

        {recipe.type === 'P' && <tr>
            <td>Allergens <br/><br/>(on this product directly)</td>
            <td>
            <div className='check-list'>
            {ALLERGENS.map(a => {

                const toggleAllergen = (e) => {
                    let newArray = recipe.allergens ? recipe.allergens.split(',') : []
                    if (e.target.checked) {
                        newArray.push(a)
                    }
                    else {
                        newArray = newArray.filter(r => r !== a)
                    }
                    newArray = [...new Set(newArray)].sort((a,b)=>(a > b ? 1 : -1));
                    setRecipe({...recipe, allergens: newArray.length ? newArray.join(',') : null })
                }
                const defaultChecked = (recipe.allergens || '').split(',').includes(a)
            
                return (<label className={defaultChecked ? 'checked' : ''}>{a}<input type="checkbox" name='allergens' defaultChecked={defaultChecked} onClick={toggleAllergen} /></label>)
            
            })}
            </div>
                
        </td>
        </tr>}

        {recipe.type === 'D' && <>
            <tr>
                <td>Product claims</td>
                <td><input style={{width:500}} name='claims'  defaultValue={recipe.claims} onChange={e => setRecipe({...recipe, claims: e.target.value })} /></td>
            </tr>  
            <tr>
                <td>Portions</td>
                <td><input style={{width:50, textAlign:'right'}} name='portions'  defaultValue={recipe.portions} onChange={e => setRecipe({...recipe, portions: Number(e.target.value) })} /></td>
            </tr> 
            <tr>
                <td>Product Dimensions</td>
                <td>Width: <input style={{width:50, textAlign:'right'}} name='product_width' defaultValue={recipe.product_width} onChange={e => setRecipe({...recipe, product_width: Number(e.target.value) || null })} />cm &nbsp;&nbsp;&nbsp;x&nbsp;&nbsp;&nbsp; Height: <input style={{width:50, textAlign:'right'}} name='product_height'  defaultValue={recipe.product_height} onChange={e => setRecipe({...recipe, product_height: Number(e.target.value) || null })} /> cm &nbsp;&nbsp;&nbsp;x&nbsp;&nbsp;&nbsp; Depth: <input style={{width:50, textAlign:'right'}} name='product_depth'  defaultValue={recipe.product_depth} onChange={e => setRecipe({...recipe, product_depth: Number(e.target.value) || null })} /> cm</td>
            </tr> 
            <tr>
                <td>Topping decorations</td>
                <td><input style={{width:500}} name='topping'  defaultValue={recipe.topping} onChange={e => setRecipe({...recipe, topping: e.target.value })} /></td>
            </tr>  
            <tr>
                <td>Fruit topping</td>
                <td><input style={{width:500}} name='fruit_topping'  defaultValue={recipe.fruit_topping} onChange={e => setRecipe({...recipe, fruit_topping: e.target.value })} /></td>
            </tr> 
            <tr>
                <td>Storage</td>
                <td><input style={{width:500}} name='storage'  defaultValue={recipe.storage} onChange={e => setRecipe({...recipe, storage: e.target.value })} /></td>
            </tr> 
            <tr>
                <td>Shelf life</td>
                <td><input style={{width:500}} name='shelf_life'  defaultValue={recipe.shelf_life} onChange={e => setRecipe({...recipe, shelf_life: e.target.value })} /></td>
            </tr> 
            <tr>
                <td>Instructions for use</td>
                <td><input style={{width:500}} name='instructions'  defaultValue={recipe.instructions} onChange={e => setRecipe({...recipe, instructions: e.target.value })} /></td>
            </tr>  
            <tr>
                <td>Packaging</td>
                <td><input style={{width:500}} name='packaging'  defaultValue={recipe.packaging} onChange={e => setRecipe({...recipe, packaging: e.target.value })} /></td>
            </tr> 
            <tr>
                <td>Packaging Dimensions</td>
                <td>Width: <input style={{width:50, textAlign:'right'}} name='packaging_width' defaultValue={recipe.packaging_width} onChange={e => setRecipe({...recipe, packaging_width: Number(e.target.value) || null })} />cm &nbsp;&nbsp;&nbsp;x&nbsp;&nbsp;&nbsp; Height: <input style={{width:50, textAlign:'right'}} name='packaging_height'  defaultValue={recipe.packaging_height} onChange={e => setRecipe({...recipe, packaging_height: Number(e.target.value) || null })} /> cm &nbsp;&nbsp;&nbsp;x&nbsp;&nbsp;&nbsp; Depth: <input style={{width:50, textAlign:'right'}} name='packaging_depth'  defaultValue={recipe.packaging_depth} onChange={e => setRecipe({...recipe, packaging_depth: Number(e.target.value) || null })} /> cm</td>
            </tr> 
            <tr>
                <td>Weight</td>
                <td>Net: <input style={{width:80, textAlign:'right'}} name='net_weight' defaultValue={recipe.net_weight} onChange={e => setRecipe({...recipe, net_weight: Number(e.target.value) || null })} />g &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Gross: <input style={{width:80, textAlign:'right'}} name='gross_weight'  defaultValue={recipe.gross_weight} onChange={e => setRecipe({...recipe, gross_weight: Number(e.target.value) || null })} /> g</td>
            </tr> 
            <tr>
                <td>Nutrition</td>
                <td>
                    <table className='nutrition'>
                        <tr>
                            <td ></td>
                            <td><b>Per 100g</b></td>
                            <td><b>Per {portionWeight}g</b></td>
                        </tr>
                        <tr>
                            <td ><b>Energy kJ</b></td>
                            <td><input style={{width:80, textAlign:'right'}} name='energy_kj' defaultValue={recipe.energy_kj} onChange={e => setRecipe({...recipe, energy_kj: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.energy_kj * portionMultiplier) / 10} /></td>
                        
                        </tr>
                        <tr>
                            <td ><b>Energy kcal</b></td>
                            <td><input style={{width:80, textAlign:'right'}} name='energy_kcal' defaultValue={recipe.energy_kcal} onChange={e => setRecipe({...recipe, energy_kcal: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.energy_kcal * portionMultiplier) / 10} /></td>
                        </tr>
                        <tr>
                            <td ><b>Fat g</b></td>
                            <td><input style={{width:80, textAlign:'right'}} name='fat' defaultValue={recipe.fat} onChange={e => setRecipe({...recipe, fat: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.fat * portionMultiplier) / 10} /></td>
                        </tr>
                        <tr>
                            <td >- of which saturates g</td>
                            <td><input style={{width:80, textAlign:'right'}} name='saturates' defaultValue={recipe.saturates} onChange={e => setRecipe({...recipe, saturates: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.saturates * portionMultiplier) / 10} /></td>
                        </tr>
                        <tr>
                            <td ><b>Carbohydrate g</b></td>
                            <td><input style={{width:80, textAlign:'right'}} name='carbs' defaultValue={recipe.carbs} onChange={e => setRecipe({...recipe, carbs: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.carbs * portionMultiplier) / 10} /></td>
                        </tr>
                        <tr>
                            <td >- of which sugars g</td>
                            <td><input style={{width:80, textAlign:'right'}} name='sugars' defaultValue={recipe.sugars} onChange={e => setRecipe({...recipe, sugars: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.sugars * portionMultiplier) / 10} /></td>
                        </tr>
                        <tr>
                            <td ><b>Protein g</b></td>
                            <td><input style={{width:80, textAlign:'right'}} name='protein' defaultValue={recipe.protein} onChange={e => setRecipe({...recipe, protein: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.protein * portionMultiplier) / 10} /></td>
                        </tr>
                        <tr>
                            <td ><b>Salt g</b></td>
                            <td><input style={{width:80, textAlign:'right'}} name='salt' defaultValue={recipe.salt} onChange={e => setRecipe({...recipe, salt: Number(e.target.value) || null })} /></td>
                            <td><input style={{width:80, textAlign:'right'}} disabled value={Math.floor(10 * recipe.salt * portionMultiplier) / 10} /></td>
                        </tr>
                    </table>
                </td>
            </tr>     
        </>}
        <tr>
            <td>Active/Visible</td>
            <td><label><input type="checkbox" name='active' defaultChecked={recipe.active} onClick={e => setRecipe({...recipe, active: Number(e.target.checked) || null })} /></label>
            &nbsp;&nbsp;<span className=''>When unchecked this item will be 'archived' and will not appear as a sub-recipe</span>
            </td>
        </tr>
        </table>

        <div className='right'>
        {recipe?.updated_at && <span className='sml'>last updated: {formatDate(recipe?.updated_at, true)}&nbsp;&nbsp;&nbsp;</span>}
                                

            <button className='clear' onClick={handleSave}>
                <FontAwesomeIcon spin={saving} icon={saving ? faSyncAlt : faSave} />&nbsp;
                Save
            </button>
        </div>
    </>
    )
}

export default RecipeForm;